import api from './index';

export const getUsers = async () => {
  const response = await api.get('/admin/users');
  return response.data;
};

export const createUser = async (userData) => {
  const response = await api.post('/auth/register', userData);
  return response.data;
};

export const createCardForUser = async (cardData) => {
  const response = await api.post('/admin/create-card', cardData);
  return response.data;
};

export const toggleCardEnabled = async (cardId) => {
  const response = await api.post(`/cards/${cardId}/toggle`);
  return response.data;
};

export const toggleUserActive = async (userId) => {
    const response = await api.post(`/auth/users/${userId}/toggle-active`);
    return response.data;
}; 